import { MapContext } from 'contexts/MapContext';
import * as RiIcons from 'react-icons/ri';
import React, { useContext, useEffect } from 'react';
import { useLayers } from 'hooks/useLayers';

import VectorLayer from 'ol/layer/Vector';
import { ToolBox } from 'screens/Dashboard/components/SideBar/ToolBox';
import { BaseSelect } from 'components/BaseSelect';

function getName(str: string) {
  const key = 'p3m:';
  const index = str?.indexOf(key);
  return index !== -1 ? 'p3m:' + str?.slice(index + key.length) : '';
}

function getLayerId(layer: any): string {
  const props = layer?.getProperties?.() ?? {};

  if (props.layertitle) return String(props.layertitle);
  if (props.uuid) return String(props.uuid);

  return '';
}

export function SplitFeaturesMenu() {
  const { getLayerAttritubeByName } = useLayers();

  const {
    map,
    splitLayer,
    handleSetSplitLayer,
  } = useContext(MapContext);


  const [vectorLayers, setVectorLayers] = React.useState<any[]>([]);

  useEffect(() => {
    if (!map) return;

    const updateLayers = () => {
      const layers = map
        .getLayers()
        .getArray()
        .filter((layer: any) => {
          if (!(layer instanceof VectorLayer)) return false;

          const props = layer?.getProperties?.() ?? {};
          return !!(props.layertitle || props.uuid);
        });

      setVectorLayers(layers);
    };

    updateLayers();

    const layersCollection = map.getLayers();

    layersCollection.on('add', updateLayers);
    layersCollection.on('remove', updateLayers);

    return () => {
      layersCollection.un('add', updateLayers);
      layersCollection.un('remove', updateLayers);
    };
  }, [map]);

  const selectedId = splitLayer ? getLayerId(splitLayer) : '';

  function getLayerLabel(layer: any) {
    const id = getLayerId(layer);
    const meta = getLayerAttritubeByName(getName(id))?.layertitle || id;
    return meta.replace(/\.(kml|geojson|zip|shp)$/i, '');
  }

  function getLayerIfPoint(layer: any): string | null {
    if (!layer) return null;

    const source = layer.getSource?.();
    if (!source) return null;

    const features = source.getFeatures?.();
    if (!features || features.length === 0) return null;

    for (let i = 0; i < features.length; i++) {
      const geom = features[i]?.getGeometry?.();
      if (geom) {
        const type = geom.getType();

        if (type === 'Point' || type === 'MultiPoint') {
          const props = layer?.getProperties?.() ?? {};
          return props.layertitle || props.uuid;
        }

        break;
      }
    }

    return null;
  }

  const disabledLayers = vectorLayers.map(l => getLayerIfPoint(l)).filter((v): v is string => v !== null);

  return (
    <ToolBox
      header={
        <>
          <RiIcons.RiScissorsCutLine />
          <span>Dividir Feições</span>
        </>
      }
    >
      <BaseSelect
        label='Camada vetorial'
        value={selectedId || 'disable'}
        onChange={handleSetSplitLayer}
        placeholder={'Selecione a camada'}
        options={vectorLayers.map(l => ({ label: getLayerLabel(l), value: getLayerId(l) }))}
        disabledLayers={disabledLayers}
        displayIcon={disabledLayers.length == 0 ? false : true}
        tooltipeMessage='A ferramenta de corte não está disponível para geometrias do tipo ponto'
      />
    </ToolBox>
  );
}